import { useCallback, useId, useState } from 'react';

import { useCurrentUserRolesAsync } from '#src/app/shared/hooks/session';
import { isLoaded } from '#src/app/shared/utils/async';

type Result = ModelHookResult<
	{
		isVisible: boolean;
		isOpen: boolean;
		panelId: string;
		headingId: string;
	},
	{
		toggle: () => void;
	}
>;

export function useStaffDrawer(): Result {
	// async roles: the drawer can mount on pages whose SSR render has no session (disallowUserData)
	const rolesState = useCurrentUserRolesAsync();
	const [isOpen, setIsOpen] = useState(false);
	const panelId = useId();
	const headingId = useId();

	const toggle = useCallback(() => setIsOpen((open) => !open), []);

	return {
		data: {
			isVisible: isLoaded(rolesState) && (rolesState.value.staff || rolesState.value.support),
			isOpen,
			panelId,
			headingId,
		},
		actions: {
			toggle,
		},
	};
}
